import React, { useContext } from "react";

import { RoutingContext } from "src/contexts";
import NewSendingDocuments from "./NewSendingDocuments";

const NewSendingDocumentsContainer: React.FC = () => {
  const { setTitle, setSubtitle } = useContext(RoutingContext);
  setTitle("Sistema de admissões");
  setSubtitle("Dashboard");

  return <NewSendingDocuments />;
};

export default NewSendingDocumentsContainer;
